type StoreProps = {
  store: string;
  country: string;
  url: { url: string };
  pixel?: { url?: string };
};

export interface Store {
  countryCode: string;
  pixel?: string;
  title: string;
  url: string;
}

const getStoreInfo = (stores: Array<StoreProps>): Array<Store> =>
  stores.map((store: StoreProps) => ({
    title: store.store,
    countryCode: store.country,
    url: store.url.url,
    pixel: store.pixel?.url,
  }));

export default getStoreInfo;
